import { render, staticRenderFns } from "./ProcessMidProducts.vue?vue&type=template&id=450228c0&scoped=true"
import script from "./ProcessMidProducts.vue?vue&type=script&lang=js"
export * from "./ProcessMidProducts.vue?vue&type=script&lang=js"
import style0 from "./ProcessMidProducts.vue?vue&type=style&index=0&id=450228c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450228c0",
  null
  
)

export default component.exports